import {Tooltip} from 'bootstrap';

export function initTooltips(elements) {
    elements.forEach((element) => {
        Tooltip.getOrCreateInstance(element);
    });
}
